import './breadprogress.scss'
export default function breadProgress(
  $location,
  $stateParams,
  $state,
  $rootScope,
  $timeout,
  BundleService,
) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      entry: '=',
      parentId: '@',
      isEvent: '@',
      isChannelBundle: '=',
    },
    templateUrl: 'app/components/breadProgress/breadProgress.html',
    link: breadProgressLink,
  }

  return directive

  function breadProgressLink($scope, $element, $attr) {
    if ($scope.isEvent === null || $scope.isEvent === undefined) {
      $scope.isEvent = false
    }
    if ($scope.isChannelBundle === null || $scope.isChannelBundle === undefined) {
      $scope.isChannelBundle = false
    }
    if ($attr.parentId === undefined) {
      $scope.items = [
        {
          step: '1',
          name: 'Details',
          className: 'todo',
          disable: false,
        },
        {
          step: '2',
          name: 'Cards',
          className: 'todo',
          disable: false,
        },
        {
          step: '3',
          name: 'Packs',
          className: 'todo',
          disable: false,
        },
        {
          step: '4',
          name: 'Reviews',
          className: 'todo',
          disable: false,
        },
        {
          step: '5',
          name: 'Checklists',
          className: 'todo',
          disable: false,
        },
      ]
    } else {
      $scope.itemOdds = [
        {
          step: '1',
          name: 'Bundle Details',
          className: 'todo',
          disable: false,
        },
        {
          step: '2',
          name: 'Collectibles',
          className: 'todo',
          disable: false,
        },
        {
          step: '3',
          name: 'Collectibles from Other Sets',
          className: 'todo',
          disable: false,
        },
        {
          step: '4',
          name: 'Collectibles from Other Channels',
          className: 'todo',
          disable: false,
        },
        {
          step: '5',
          name: 'Odds',
          className: 'todo',
          disable: false,
        },
        {
          step: '6',
          name: 'Bounty Pack',
          className: 'todo',
          disable: false,
        },
      ]
    }

    if ($scope.isChannelBundle) {
      $scope.itemOdds = [
        {
          step: '1',
          name: 'Bundle Details',
          className: 'todo',
          disable: false,
        },
        {
          step: '2',
          name: 'Collectibles from this Channel',
          className: 'todo',
          disable: false,
        },
        // {
        //   step: '3',
        //   name: 'Collectibles from Other Channels',
        //   className: 'todo',
        //   disable: false,
        // },
        {
          step: '4',
          name: 'Odds',
          className: 'todo',
          disable: false,
        },
        // {
        //   step: '5',
        //   name: 'Bounty Pack',
        //   className: 'todo',
        //   disable: false,
        // },
      ]
    }

    if ($attr.entry === 'Details') {
      $scope.items[0].className = 'active'
    } else if ($attr.entry === 'Cards') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'active'
    } else if ($attr.entry === 'Packs') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'active'
    } else if ($attr.entry === 'Reviews') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'todo'
      $scope.items[2].step = ''
      $scope.items[3].className = 'active'
      $scope.items[3].href = 'pub.reviews'
    } else if ($attr.entry === 'Checklists') {
      $scope.items[0].className = 'todo'
      $scope.items[0].step = ''
      $scope.items[1].className = 'todo'
      $scope.items[1].step = ''
      $scope.items[2].className = 'todo'
      $scope.items[2].step = ''
      $scope.items[3].className = 'todo'
      $scope.items[3].step = ''
      $scope.items[3].href = 'pub.reviews'
      $scope.items[4].className = 'active'
    }

    if ($scope.isChannelBundle) {
      if ($attr.entry === 'Odd1') {
        $scope.itemOdds[0].className = 'active'
      } else if ($attr.entry === 'FromThisChannel') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'active'
      } else if ($attr.entry === 'Odd4') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'active'
      } else if ($attr.entry === 'Odd5') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'todo'
        $scope.itemOdds[2].step = ''
        $scope.itemOdds[3].className = 'active'
      } else if ($attr.entry === 'Odd6') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'todo'
        $scope.itemOdds[2].step = ''
        $scope.itemOdds[3].className = 'todo'
        $scope.itemOdds[3].step = ''
        $scope.itemOdds[4].className = 'active'
      }
    } else {
      if ($attr.entry === 'Odd1') {
        //odds
        $scope.itemOdds[0].className = 'active'
      } else if ($attr.entry === 'Odd2') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'active'
      } else if ($attr.entry === 'Odd3') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'active'
      } else if ($attr.entry === 'Odd4') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'todo'
        $scope.itemOdds[2].step = ''
        $scope.itemOdds[3].className = 'active'
      } else if ($attr.entry === 'Odd5') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'todo'
        $scope.itemOdds[2].step = ''
        $scope.itemOdds[3].className = 'todo'
        $scope.itemOdds[3].step = ''
        $scope.itemOdds[4].className = 'active'
      } else if ($attr.entry === 'Odd6') {
        $scope.itemOdds[0].className = 'todo'
        $scope.itemOdds[0].step = ''
        $scope.itemOdds[1].className = 'todo'
        $scope.itemOdds[1].step = ''
        $scope.itemOdds[2].className = 'todo'
        $scope.itemOdds[2].step = ''
        $scope.itemOdds[3].className = 'todo'
        $scope.itemOdds[3].step = ''
        $scope.itemOdds[4].className = 'todo'
        $scope.itemOdds[4].step = ''
        $scope.itemOdds[5].className = 'active'
      }
    }

    $scope.link = function (item) {
      var path = $location.$$path,
        id,
        channelId = localStorage.getItem('channelId')
      if (path.indexOf('channels') === -1) {
        id = $stateParams.parentId
      } else {
        id = $stateParams.id
      }

      switch (item.name) {
        case 'Details':
          $state.go('pub.channels.sets.edit', {
            parentId: channelId,
            id: id,
          })
          break
        case 'Cards':
          $state.go('pub.collectibles', { parentId: id })
          break
        case 'Packs':
          $state.go('pub.bundles', { parentId: id })
          break
        case 'Reviews':
          $state.go('pub.reviews', { parentId: id })
          break
        case 'Checklists':
          $state.go('pub.set_checklists', {
            parentId: id,
          })
          break

        //odds
        case 'Bundle Details':
          $state.go('pub.bundles.step1', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Collectibles':
          $state.go('pub.bundles.step2', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Collectibles from this Channel':
          $state.go('pub.bundles.from_this_channel', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Collectibles from Other Sets':
          $state.go('pub.bundles.step3', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Collectibles from Other Channels':
          $state.go('pub.bundles.step4', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Odds':
          $state.go('pub.bundles.step5', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            create: $stateParams.create,
            post: $stateParams.post,
          })
          break
        case 'Bounty Pack':
          $state.go('pub.bundles.step6', {
            parentId: $attr.parentId,
            id: $stateParams.id,
          })
          break
      }
    }

    $scope.publish = function () {
      swal(
        {
          title: 'Are you sure',
          text: 'Bundle will be published at the time indicated in the "published at" field',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          closeOnConfirm: true,
          type: 'warning',
          animation: 'slide-from-top',
          allowEscapeKey: false,
          allowOutsideClick: false,
        },
        function (isConfirm) {
          if (!isConfirm) {
            return
          } else {
            BundleService.publish($stateParams.id).then(
              function () {
                toastr.success('Published!')
              },
              function (err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                $timeout(function () {
                  swal({
                    title: 'Pack Incomplete',
                    text: html,
                    html: true,
                  })
                }, 500)
              },
            )
          }
        },
      )
    }

    $scope.soldout = function () {
      BundleService.update($stateParams.parentId, $stateParams.id, {
        st: 2,
      }).then(function () {
        swal('Sold Out', '', 'success')
      })
    }
  }
}
